import { render } from "./ConfirmationForm.vue?vue&type=template&id=5c10a0d2&scoped=true&ts=true"
import script from "./ConfirmationForm.vue?vue&type=script&lang=ts"
export * from "./ConfirmationForm.vue?vue&type=script&lang=ts"

import "./ConfirmationForm.vue?vue&type=style&index=0&id=5c10a0d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c10a0d2"]])

export default __exports__